import { HTMLAttributes } from "react";

interface RecLeaguesIconProps extends HTMLAttributes<SVGElement> {}

const RecLeaguesIcon = ({}: RecLeaguesIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
    >
      <path
        d="M2 11C2 8.23858 4.23858 6 7 6H33C35.7614 6 38 8.23858 38 11V33C38 35.7614 35.7614 38 33 38H7C4.23858 38 2 35.7614 2 33V11Z"
        stroke="#048CDD"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 2L13 10"
        stroke="#048CDD"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 20L10 20"
        stroke="#048CDD"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M30 20L24 20"
        stroke="#048CDD"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M16 28L10 28"
        stroke="#048CDD"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M30 28L24 28"
        stroke="#048CDD"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M27 2L27 10"
        stroke="#048CDD"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default RecLeaguesIcon;
